import { Button, Modal, Spin } from "antd";
import axios from '../../../context/axiosConfig';
import { useAuth } from "../../../context/AuthContext";
import { useState } from 'react';
import { usePaginationPrzelewy } from "../../../context/PaginationContextPrzelewy";
import UserCan from "../../../components/UserCan";

const GenerateXML = ({ ids, setSelectedRowKeys }) => {
    const user = useAuth();
    const { pagination, setPagination } = usePaginationPrzelewy();
    const [isLoading, setIsLoading] = useState(false); // Loader state

    const generateXML = async () => {
        setIsLoading(true); // Show loader
        try {
            const response = await axios.post("/przelewy/generate/xml", {
                ids: ids,
                user: user.user.user.mlg_users_id
            });

            const fileobject = await axios.post("/przelewy/download/xml", {
                filename: response.data.data
            }, {
                responseType: 'blob' // Important to handle file as binary
            });

            // Create a Blob from the response
            const blob = new Blob([fileobject.data], { type: 'application/xml' });
            const link = document.createElement('a');

            // Create a link to the file
            link.href = window.URL.createObjectURL(blob);
            link.download = `${response.data.data}`; // Ensure correct file extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Błąd pobierania pliku:", error);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
                setSelectedRowKeys([])
                setPagination({...pagination, reload: !pagination.reload})
            }, 1000)
        }
    };

    return (
        <>
            <UserCan perms={['can_generate_xml']}><Button type="primary" onClick={generateXML} disabled={!ids.length > 0}>
                Wygeneruj przelewy
            </Button>
            </UserCan>

            <Modal
                open={isLoading}
                footer={null}
                closable={false}
                centered
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <Spin size="large" />
                    <p style={{ marginTop: 20 }}>Generowanie pliku XML, proszę czekać...</p>
                </div>
            </Modal>
        </>
    );
};

export default GenerateXML;
